// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48571322","455":"01f93e08","977":"97c7ce98"}[chunkId] + ".chunk.js";
};